/**
 * Returns array of values in sorted order.
 * Expects initial arrays to be in sorted order.
 */
export const combineInAscSortOrder = <T>(arr1: T[], arr2: T[]): T[] => {
  const result = [];

  let arr1Index = 0;
  const arr1Length = arr1.length;

  let arr2Index = 0;
  const arr2Length = arr2.length;

  while (arr1Index < arr1Length && arr2Index < arr2Length) {
    if (arr1[arr1Index] < arr2[arr2Index]) {
      result.push(arr1[arr1Index++]);
    } else {
      result.push(arr2[arr2Index++]);
    }
  }

  if (arr1Index < arr1Length) {
    result.push(...arr1.slice(arr1Index));
  }

  if (arr2Index < arr2Length) {
    result.push(...arr2.slice(arr2Index));
  }

  return result;
};
